import { useSelector } from 'react-redux';
import { Box, Chip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import TeamActions from './TeamActions';
import CustomPagination from '../../../components/customPagination';

const TeamTable = () => {
  const members = useSelector((state) => state.org.org.members);

  const columns = [
    {
      field: 'name',
      headerName: 'User Name',
      flex: 0.7,
    },
    {
      field: 'email',
      headerName: 'User Email',
      flex: 1.5,
    },
    {
      field: 'permissions.business_profiles',
      headerName: 'Business Profile Management',
      flex: 1,
      renderCell: ({ row }) =>
        row.permissions?.business_profiles === 1
          ? 'Read Only'
          : row.permissions?.business_profiles
            ? 'Read & Write'
            : 'NA',
    },
    {
      field: 'permissions.customers',
      headerName: 'Customer Management',
      flex: 1,
      renderCell: ({ row }) =>
        row.permissions?.customers === 1 ? 'Read Only' : row.permissions?.customers ? 'Read & Write' : 'NA',
    },
    {
      field: 'permissions.suppliers',
      headerName: 'Supplier Management',
      flex: 1,
      renderCell: ({ row }) =>
        row.permissions?.suppliers === 1 ? 'Read Only' : row.permissions?.suppliers ? 'Read & Write' : 'NA',
    },
    {
      field: 'permissions.documents',
      headerName: 'Document Creation',
      flex: 1,
      renderCell: ({ row }) =>
        row.permissions?.documents === 1 ? 'Read Only' : row.permissions?.documents ? 'Read & Write' : 'NA',
    },
    {
      field: 'permissions',
      headerName: 'Allowed Business Profiles',
      flex: 2,
      renderCell: ({ row }) => {
        const profiles = row.permissions?.allowed_business_profiles;
        if (!profiles || profiles.length === 0) {
          return <Chip label="All" size="small" />;
        }
        return (
          <>
            {profiles.map((profile) => (
              <Chip key={profile.profile_id} label={profile.name} size="small" />
            ))}
          </>
        );
      },
    },
    {
      field: 'is_active',
      headerName: 'Status',
      flex: 1,
      renderCell: ({ row }) => {
        return row.is_active ? 'Active' : 'Inactive';
      },
    },
    {
      field: 'row',
      headerName: 'Actions',
      flex: 0.5,
      renderCell: (params) => {
        return <TeamActions member={params.row} />;
      },
    },
  ];

  return (
    <Box>
      <DataGrid
        rows={members}
        columns={columns}
        getRowId={(row) => row._id}
        disableRowSelectionOnClick
        slots={{
          pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default TeamTable;
